import {
  useOverviewOrgApiKeysQuery,
  useOverviewSecretsQuery,
  useOverviewUserApiKeysQuery,
  useOverviewUsersQuery,
  useOverviewWebhookSecretsQuery,
} from './__generated__/queries.generated';

function useUsers() {
  const { data: users, loading } = useOverviewUsersQuery({
    fetchPolicy: 'cache-first',
  });

  return {
    users: users?.users,
    loading,
  };
}

function useApiKeys() {
  const { data: userApiKeys, loading: isUserApiKeysLoading } = useOverviewUserApiKeysQuery({
    fetchPolicy: 'cache-first',
  });

  const { data: orgApiKeys, loading: isOrgApiKeysLoading } = useOverviewOrgApiKeysQuery({
    fetchPolicy: 'cache-first',
  });

  return {
    apiKeys: [...(userApiKeys?.userApiKeys || []), ...(orgApiKeys?.orgApiKeys || [])].filter(
      ({ revoked }) => !revoked,
    ),
    loading: isUserApiKeysLoading || isOrgApiKeysLoading,
  };
}

function useSecrets() {
  const { data: secrets, loading: isSecretsLoading } = useOverviewSecretsQuery({
    fetchPolicy: 'cache-first',
  });

  const { data: webhookSecrets, loading: isWebhookSecretsLoading } = useOverviewWebhookSecretsQuery(
    {
      fetchPolicy: 'cache-first',
    },
  );

  return {
    secrets: [...(secrets?.secrets || []), ...(webhookSecrets?.webhookSecrets || [])],
    loading: isSecretsLoading || isWebhookSecretsLoading,
  };
}

export { useUsers, useApiKeys, useSecrets };
